var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "editor-wrapper",
      attrs: { disabled: _vm.disabled },
      on: {
        dragover: function($event) {
          $event.stopPropagation()
        },
        drop: function($event) {
          $event.stopPropagation()
        }
      }
    },
    [
      _c("div", { ref: "editor" }),
      _vm._v(" "),
      _vm.hasEmojis
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.emojiMartOpened,
                  expression: "emojiMartOpened"
                }
              ],
              staticClass: "emoji-mart-wrapper"
            },
            [
              _c("picker", {
                ref: "emoji-picker",
                attrs: {
                  set: "twitter",
                  title: "Pick your emoji…",
                  emoji: "point_up"
                },
                on: { select: _vm.addEmoji, onClick: _vm.addEmoji }
              })
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }